module.exports={"Star Rating":"Star Rating","# star(s)":"{currentRating, plural, =1{# star} other{# stars}}"};